export class QzNotRunningError extends Error {
  constructor(message) {
    super(message);
    this.name = 'QzNotRunningError';
    this.code = 'QZ_NOT_RUNNING';
  }
}

export class QzPermissionError extends Error {
  constructor(message) {
    super(message);
    this.name = 'QzPermissionError';
    this.code = 'QZ_PERMISSION';
  }
}

export class PrinterNotFoundError extends Error {
  constructor(printerName) {
    super(`The configured label printer was not found: ${printerName}`);
    this.name = 'PrinterNotFoundError';
    this.code = 'PRINTER_NOT_FOUND';
    this.printerName = printerName;
  }
}

export class QzPrintError extends Error {
  constructor(message, cause) {
    super(message);
    this.name = 'QzPrintError';
    this.code = 'QZ_PRINT_FAILED';
    this.cause = cause;
  }
}
